// This file is generated automatically by scripts/generate-icon.js. Don't modify it.

import AwardGeneral from '../_raw/award/icon_award_general.svg';
import withIconProps from '../withIconProps';

export default withIconProps(AwardGeneral, { shouldSetDefaultSize: false });
